import {Container} from 'src/design/atoms/Container';
import {Loader} from 'src/design/atoms/Loader';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {Title} from 'src/design/atoms/Title';
import React from 'react';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const documentTitle = 'Loading...';

export interface LoadingPageProps {
  title?: string;
  message?: string;
}
export const LoadingPage: React.FC<LoadingPageProps> = ({message}) => {
  useSetDocumentTitle(documentTitle);

  return (
    <Container size={420} my={40}>
      <Stack gap="lg" align="center">
        <Title ta="center">Loading...</Title>
        <Text c="dimmed" size="sm">
          {message ?? "We're loading your work right now. One moment, please."}
        </Text>
        <Loader size="lg" />
      </Stack>
    </Container>
  );
};
